import React, { FunctionComponent, useMemo, useState } from 'react'
import { useCartao } from '../../../../hooks/useCartao'
import { useAuth } from '../../../../../auth/hooks/auth'
import { Divider, Title } from '../../../Pagamento/styles'
import { ContainerCards, TitleDadosConta } from './styles'
import { Button, Card, CardContent, Grid } from '@material-ui/core'
import { HiOutlineEye, HiOutlineEyeOff, HiRefresh } from 'react-icons/hi'
import { isValidValue } from '../../../../../../shared/utils/validates'
import { numberToCurrency } from '../../../../../../shared/utils/formatters'
import { colors } from '../../../../../../shared/styles/colors'
import { useFrotista } from '../../../../../user/hooks/useFrotista'

interface DadosContaProp {
  openModalSelectFrotista: () => void
}
const DadosConta: FunctionComponent<DadosContaProp> = ({
  openModalSelectFrotista,
}) => {
  const { cartao } = useCartao()
  const { frotistas } = useFrotista()
  const { name } = useAuth()

  const [mostrarSaldo, setMostrarSaldo] = useState(false)

  const titular = useMemo(() => {
    if (!isValidValue(cartao)) {
      return '-'
    }
    return cartao?.titular ?? name
  }, [cartao])

  const multiplasContas = useMemo(() => {
    return isValidValue(frotistas) && frotistas.length > 1
  }, [frotistas])

  return (
    <ContainerCards>
      <Grid container spacing={2}>
        <Grid item sm={6}>
          <Card
            variant={'outlined'}
            style={{
              padding: 8,
              height: 170,
            }}
          >
            <CardContent>
              <Grid container spacing={1}>
                <Grid item sm={12}>
                  <Title
                    style={{
                      fontWeight: 600,
                    }}
                  >
                    Saldo em conta
                  </Title>
                </Grid>

                <Grid item sm={12}>
                  <Divider />
                </Grid>

                <Grid item sm={12}>
                  <span
                    style={{
                      fontFamily: 'Inter, Roboto, sans serif',
                      fontWeight: 700,
                      fontSize: 32,
                      marginRight: 8,
                    }}
                  >
                    {mostrarSaldo && isValidValue(cartao?.saldo)
                      ? numberToCurrency(
                          cartao?.saldo?.valor_saldo_disponivel ?? 0,
                        )
                      : '*************'}
                  </span>

                  {mostrarSaldo ? (
                    <HiOutlineEyeOff
                      size={20}
                      style={{
                        cursor: 'pointer',
                      }}
                      onClick={() =>
                        isValidValue(cartao) && setMostrarSaldo(!mostrarSaldo)
                      }
                    />
                  ) : (
                    <HiOutlineEye
                      size={20}
                      style={{
                        cursor: 'pointer',
                      }}
                      onClick={() =>
                        isValidValue(cartao) && setMostrarSaldo(!mostrarSaldo)
                      }
                    />
                  )}
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
        <Grid item sm={6}>
          <Card
            variant={'outlined'}
            style={{
              padding: 8,
              height: 170,
            }}
          >
            <CardContent>
              <Grid container spacing={multiplasContas ? 0 : 1}>
                <Grid item xs={multiplasContas ? 6 : 12}>
                  <Title
                    style={{
                      fontWeight: 600,
                    }}
                  >
                    Dados da conta
                  </Title>
                </Grid>
                {multiplasContas && (
                  <>
                    <Grid item xs={2} sm={6} style={{ textAlign: 'right' }}>
                      <Button
                        startIcon={<HiRefresh />}
                        variant={'outlined'}
                        size={'small'}
                        onClick={openModalSelectFrotista}
                        style={{
                          textTransform: 'capitalize',
                          color: colors.green,
                          borderColor: colors.green,
                          backgroundColor: colors.white,
                        }}
                      >
                        Trocar Conta
                      </Button>
                    </Grid>
                  </>
                )}

                <Grid item sm={12}>
                  <Divider />
                </Grid>

                <Grid item sm={9} lg={8} xs={6} xl={6}>
                  <TitleDadosConta
                    $fontWeight={400}
                    $fontSize={14}
                    $color={'#6D787D'}
                  >
                    Titular
                  </TitleDadosConta>
                </Grid>
                <Grid item sm={3} lg={4} xs={6} xl={6}>
                  <TitleDadosConta
                    $fontWeight={400}
                    $fontSize={14}
                    $color={'#6D787D'}
                  >
                    Cartão
                  </TitleDadosConta>
                </Grid>
                <Grid item sm={9} lg={8} xs={6} xl={6}>
                  <TitleDadosConta $fontWeight={600} $fontSize={16}>
                    {titular}
                  </TitleDadosConta>
                </Grid>
                <Grid item sm={3} lg={4} xs={6} xl={6}>
                  <TitleDadosConta $fontWeight={600} $fontSize={16}>
                    {cartao.identificador ?? '-'}
                  </TitleDadosConta>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </ContainerCards>
  )
}

export default DadosConta
